import { render, staticRenderFns } from "./ProjectPageTasks.vue?vue&type=template&id=10ccdfc8&scoped=true&"
import script from "./ProjectPageTasks.vue?vue&type=script&lang=js&"
export * from "./ProjectPageTasks.vue?vue&type=script&lang=js&"
import style0 from "./ProjectPageTasks.vue?vue&type=style&index=0&id=10ccdfc8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ccdfc8",
  null
  
)

export default component.exports